<template>
  <div v-waiting.center="isLoading = { isLoading: uploading }" class="input-container">
    <form @submit.prevent="submit">
      <input v-model="commentString" placeholder="Comment" />
      <div class="buttons">
        <span class="attach">
          <label for="file-input">
            <img :style="{ height: '23px' }" :src="require('@/assets/img/attach.png')" />
          </label>
          <input id="file-input" type="file" accept="image/*" @change="selectImage" />
        </span>
        <div class="send" @click="submit">
          <img v-if="commentString.length" :src="require('@/assets/img/send.png')" />
          <img v-else class="disable" :src="require('@/assets/img/sending_disable.png')" />
        </div>
      </div>
    </form>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import imageCompression from 'browser-image-compression';
import waiting from '@/components/loading/waiting';
import { logger } from '@/common/api/logger';
import { parseErrorMessage } from '@/common/error';

@Component({
  directives: {
    waiting,
  },
})
export default class Input extends Vue {
  @Prop({ default: false }) uploading!: boolean;
  commentString: string = '';
  submit(comment: string) {
    if (this.commentString.length) {
      this.$emit('submit', this.commentString);
      this.commentString = '';
    }
  }
  async selectImage(event: any) {
    if (!event.target.files.length) return;
    this.$emit('start-uploading');
    const imageFile = event.target.files[0];
    let options = {
      maxSizeMB: 0.3,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };
    try {
      const compressedFile = await imageCompression(imageFile, options);
      this.$emit('attach', compressedFile, this.commentString);
      this.commentString = '';
    } catch (error) {
      logger.error('[MY_REQUEST] Select image failed', { error: parseErrorMessage(error) });
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variable.scss';
.input-container {
  @extend.text-regular;
  width: 100%;
  height: 100%;
  min-height: 5.5rem;
  background: $off_white;
  padding: 2rem 1.6rem 2rem 1.9rem;
  display: flex;
  form {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .buttons {
      display: flex;
      align-items: center;
      .attach {
        transform: rotate(45deg);
        label {
          cursor: pointer;
        }
        input {
          display: none;
        }
      }
      .send {
        margin-left: 2rem;
        cursor: pointer;
        .disable {
          cursor: auto;
        }
      }
    }
    input {
      flex: 1;
      height: 16px;
      border: none;
      &:focus {
        outline: 0;
        border: none;
      }
    }
  }
}
</style>
